import React from 'react'
import { processDateInput } from '../DateInput'
import './numpad.less'

const keys: { label: string; class: string; id: string }[] = [
  { label: '1', class: 'number', id: 'numpad-1' },
  { label: '2', class: 'number', id: 'numpad-2' },
  { label: '3', class: 'number', id: 'numpad-3' },
  { label: '4', class: 'number', id: 'numpad-4' },
  { label: '5', class: 'number', id: 'numpad-5' },
  { label: '6', class: 'number', id: 'numpad-6' },
  { label: '7', class: 'number', id: 'numpad-7' },
  { label: '8', class: 'number', id: 'numpad-8' },
  { label: '9', class: 'number', id: 'numpad-9' },
  { label: '←', class: 'backspace', id: 'numpad-backspace' },
  { label: '0', class: 'number', id: 'numpad-0' },
]

const EMPTY_DATE = '  .  .  '

interface Props {
  input?: HTMLInputElement
  onChange: (value: string) => void
  format?: string
}

const insertToString = (start: number, end: number, val: string, key: string): string => {
  return val.substr(0, start) + key + val.substr(end, val.length)
}
const removeOneString = (start: number, end: number, val: string): string => {
  return start === 0
    ? val
    : start === end
    ? val.substr(0, start - 1) + val.substr(end, val.length - 1)
    : val.substr(0, start) + val.substr(end, val.length - 1)
}

const processStringInput = (input: HTMLInputElement, key: string, start: number, end: number, val: string) => {
  let newValue
  if (key === '←') {
    newValue = removeOneString(start, end, val)
    input.value = newValue
    const cursor = start === 0 ? 0 : start === end ? start - 1 : start
    input.focus()
    input.setSelectionRange(cursor, cursor)
  } else if (start === end && end === val.length) {
    newValue = val + key
    input.value = val + key
    input.focus()
  } else {
    newValue = insertToString(start, end, val, key)
    input.value = newValue
    const cursor = start + 1
    input.focus()
    input.setSelectionRange(cursor, cursor)
  }
  return newValue
}

const onClick = (key: string, onChange: (value: string) => void, input?: HTMLInputElement, format?: string) => {
  if (!input) {
    return
  }
  const start = input.selectionStart || 0
  const end = input.selectionEnd || 0
  let val = input.value
  if (format === 'date') {
    const maxDateLength = 8
    processDateInput(input, key, start, val || EMPTY_DATE, maxDateLength)
  } else {
    processStringInput(input, key, start, end, val)
  }
  onChange(input.value)
}

export const Numpad: React.FC<Props> = ({ input, onChange, format }: Props) => (
  <div className="numpad">
    {keys.map((item) => (
      <div
        id={item.id}
        className={`num-key ${item.class}`}
        key={item.label}
        onClick={() => onClick(item.label, onChange, input, format)}
      >
        <div>{item.label}</div>
      </div>
    ))}
  </div>
)
